"use client"

// src/components/collapse.ts
var Collapse = {
  baseStyle: {
    w: "100%"
  },
  defaultProps: {
    animationOpacity: true,
    endingHeight: "auto",
    startingHeight: 0
  }
};

export {
  Collapse
};
//# sourceMappingURL=chunk-RFLV3DUQ.mjs.map